export enum SearchErrorCode {
    INCOMPLETE_RESPONSE = 'INCOMPLETE_RESPONSE',
    EMPTY_ERROR_CODE = 'EMPTY_ERROR_CODE',
    BOOKING_IS_NON_CANCELLABLE_STATE_ON_SUPPLIER_ERROR = 'BOOKING_IS_NON_CANCELLABLE_STATE_ON_SUPPLIER_ERROR',
    PRODUCT_CANCELLATION_VALIDATION_FAILED_ERROR = 'PRODUCT_CANCELLATION_VALIDATION_FAILED_ERROR',
    BOOKING_DETAILS_IS_MISSING_OR_INVALID_ERROR = 'BOOKING_DETAILS_IS_MISSING_OR_INVALID_ERROR',
    PAST_BOOKING_DATE_ERROR = 'PAST_BOOKING_DATE_ERROR',
    EXTERNAL_ERROR = 'EXTERNAL_ERROR',
    SUPPLY_ERROR = 'SUPPLY_ERROR',
    TECHNICAL_ERROR = 'TECHNICAL_ERROR',
    BUSINESS_ERROR = 'BUSINESS_ERROR',
    INTERNAL_ERROR = 'INTERNAL_ERROR',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
}
